import DashboardHeader from './header/script';
import DashboardLaunch from './launch/script';
import DashboardLocations from './locations/script';
import DashboardMap from './map/script';
import DashboardOffice from './office/script';
import DashboardSonos from './sonos/script';
import DashboardStage from './stage/script';


export default {
	[DashboardHeader.selector]: DashboardHeader,
	[DashboardLaunch.selector]: DashboardLaunch,
	[DashboardLocations.selector]: DashboardLocations,
	[DashboardMap.selector]: DashboardMap,
	[DashboardOffice.selector]: DashboardOffice,
	[DashboardSonos.selector]: DashboardSonos,
	[DashboardStage.selector]: DashboardStage
};
